export class RSHistoryHelper
{
	/**
	 * @static
	 * @public
	 */
	static back()
	{
		if (typeof history !== 'undefined') history.back();
		else window.history.back();
	}
	
	
	/**
	 * @static
	 * @public
	 */
	static forward()
	{
		if (typeof history !== 'undefined') history.forward();
		else window.history.forward();
	}
	
	
	/**
	 * @param {?string} title
	 * @param {?string} url
	 * @param {?Object} data
	 * @static
	 * @public
	 */
	static pushState(title, url = null, data = null)
	{
		if ((title == null) && (url == null) && (data == null)) return;
		
		if (
			(url != null) &&
			(url !== '') &&
			url.startsWith('//')
		)
		{
			url = url.substring(1);
		}
		
		if (data == null)
		{
			data = { title: title };
			if ((url != null) && (url !== '')) data.url = url;
		}
		
		if (typeof history !== 'undefined') history.pushState(data, title, url);
		else window.history.pushState(data, title, url);
	}
	
	
	/**
	 * @param {?string} title
	 * @param {?string} url
	 * @param {?Object} data
	 * @static
	 * @public
	 */
	static replaceState(title, url = null, data = null)
	{
		if ((title == null) && (url == null) && (data == null)) return;
		
		if (data == null)
		{
			data = { title: title };
			if ((url != null) && (url !== '')) data.url = url;
		}
		
		if (typeof history !== 'undefined') history.replaceState(data, title, url);
		else window.history.replaceState(data, title, url);
	}
}
